module.exports = __webpack_public_path__ + "static/media/for-sale-rafiki-business.9bd5929a.svg";